import React, { useState } from 'react'
import { ManageGeneralChartState } from '../../hooks/use-manage-general-chart'
import ManageGeneralChartControlButton from './manage-general-chart-control-buttons'
import ManageGeneralChartGeneralData from './manage-general-chart-general-data'
import ManageGeneralChartParties from './manage-general-chart-parties'
import ManageGeneralChartRaces from './manage-general-chart-races'
import { DevTool } from "@hookform/devtools"

const ManageGeneralChartForm: React.FC<{
  state: ManageGeneralChartState
}> = ({ state }) => {
  
  const [errors, setErrors] = useState({})

    const watchCandidateNamesField = state.form.watch('showCandidateNames')

  return (
    <>
      <form
        className="container w-full mx-auto"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <ManageGeneralChartGeneralData
          state={state}
          candidatesNamesChecked={watchCandidateNamesField}
          setCandidatesNamesChecked={() => state.form.setValue('showCandidateNames', !watchCandidateNamesField)}
        />
        <ManageGeneralChartParties state={state} />
        <ManageGeneralChartRaces
          state={state}
          handleErrors={setErrors}
          errors={errors}
          candidatesNamesChecked={watchCandidateNamesField}
        />
      </form>
      <ManageGeneralChartControlButton errors={errors} state={state} />

      <DevTool control={state.form.control} />
    </>
  )
}

export default ManageGeneralChartForm
